import { BaseService } from "../base/base.service";
import { PlatformLocation } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { PartnerItem } from "app/models/proizvodnja/lookups/PartnerItem";
import { Observable } from "rxjs";
import { AppModulePath } from "app/models/app-module-path";
import {catchError, map} from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';

@Injectable()
export class PartnerItemService extends BaseService {

  private unresolvedUrl = '/api/partner-item/unresolved/';
  private byPartnerUrl = '/api/partner-item/by-partner/';
  private allByPartnerUrl = '/api/partner-item/all/';
  private mapUrl = '/api/partner-item/mapItems';
  private getByPibUrl = '/api/partner-item/getByPib/';


  constructor(
    protected injector: Injector,
    protected http2: HttpClient,
    protected platformLocation: PlatformLocation
  ) {
    super(injector, http2, platformLocation);
  }

  listUnresolved(partnerId: string): Observable<PartnerItem[]> {
    return this.get<PartnerItem[]>(
      this.unresolvedUrl + partnerId,
      AppModulePath.ULAZNA_OTPREMNICA
    ).pipe(
      map(res => res.map(o => new PartnerItem(o))),
      catchError(this.handleError)
    );
  }

  listByPartner(partnerId: string): Observable<PartnerItem[]> {
    return this.get<PartnerItem[]>(
      this.byPartnerUrl + partnerId,
      AppModulePath.PARTNER_ITEM
    ).pipe(
      map(res => res.map(o => new PartnerItem(o))),
      catchError(this.handleError)
    );
  }

  /**
   * All partner_item rows (mapped + unmapped) for ulazna-otpremnica article mapping.
   * Never calls /unresolved/ (unmapped-only).
   */
  listAllPartnerItems(partnerId: string): Observable<PartnerItem[]> {
    return this.fetchAllPartnerItems(this.byPartnerUrl + partnerId).pipe(
      catchError(() => this.fetchAllPartnerItems(this.allByPartnerUrl + partnerId)),
    );
  }

  /** @deprecated Use listAllPartnerItems */
  listAllForMapping(partnerId: string): Observable<PartnerItem[]> {
    return this.listAllPartnerItems(partnerId);
  }

  private fetchAllPartnerItems(url: string): Observable<PartnerItem[]> {
    return this.get<PartnerItem[]>(url, AppModulePath.ULAZNA_OTPREMNICA).pipe(
      map((res) => this.mapPartnerItems(res)),
      catchError(this.handleError),
    );
  }

  private mapPartnerItems(res: any[]): PartnerItem[] {
    return (res || []).map((o) => this.toPartnerItem(o));
  }

  private toPartnerItem(o: any): PartnerItem {
    const pi = new PartnerItem(o);
    let rawItemId = pi.itemId;

    if ((rawItemId == null || rawItemId === undefined) && o && o.item_id != null) {
      rawItemId = o.item_id;
    }

    if (rawItemId != null && rawItemId !== undefined && String(rawItemId).trim() !== '') {
      pi.itemId = String(rawItemId).trim();
    } else {
      pi.itemId = null;
    }

    return pi;
  }

  mapItemSave(partnerItemId: number, itemId: string): Observable<void> {
    return this.post<void>(
      this.mapUrl,
      AppModulePath.ULAZNA_OTPREMNICA,
      { partnerItemId, itemId }
    ).pipe(
      catchError(this.handleError)
    );
  }

  getByPib(pib: string): Observable<any> {
  return this.get<any>(
    this.getByPibUrl + pib,
    AppModulePath.ULAZNA_OTPREMNICA
  ).pipe(
    map(res => res),
    catchError(this.handleError)
  );
}


}
